import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { Button, Checkbox, Divider, Grid, Typography, capitalize } from '@mui/material';
import React from 'react';
import { ProductProviderOptions } from '../../staticData/tableHead';

const PriceComponent = ({ product, handleBuyNow }) => {
  const providerOption = ProductProviderOptions.find(
    (option) => option.value === product.provider_name
  );
  return (
    <Grid
      item
      xs
      sx={{
        py: '16px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '12px',
        justifyContent: 'center',
      }}>
      <img
        src={product.icon}
        loading="lazy"
        title={product.provider_name}
        style={{
          maxHeight: '30px', 
          width: '30px', 
          height: 'auto', 
          flexShrink: 0,
        }}
        alt="product.provider_name"
      />
      <Divider
        orientation="vertical"
        flexItem
        sx={{
          borderColor: 'black',
          opacity: 1,
        }}
      />
      <Grid container item justifyContent="flex-start" xs={7}>
        <Typography
          variant="h6"
          sx={{
            fontSize: ' 16px',
            fontWeight: '400',
            color: 'var(--Black, #000)',
          }}>
           $ {parseFloat(product.price).toLocaleString('en-US', {
                maximumFractionDigits: 2,
              })} at {providerOption ? providerOption.label : capitalize(product.provider_name)}
        </Typography>
      </Grid>
      <Grid container item justifyContent="flex-end" xs>
        <Button
          variant="contained"
          onClick={() => handleBuyNow(product.url, product.provider_name)}
          sx={{
            borderRadius: ' 54px',
            background: 'var(--Black, #000)',
            '&:hover': {
              background: 'var(--Black, #000)',
            },
            p: 0,
          }}>
          <Typography
            sx={{
              color: 'var(--White, #FFF)',
              fontSize: '11px',
              fontWeight: 600,
              p: '5px 10px',
              textTransform: 'none',
            }}>
            Buy now
          </Typography>
        </Button>
      </Grid>
    </Grid>
  );
};

const SingleProductMobile = ({
  product,
  handleBuyNow,
  handlePurchaseForm,
  setSelectedProduct,
  type,
  selectedProduct,
}) => {
  const isChecked = product.id === selectedProduct?.id;

  return (
    <>
      <Grid
        item
        xs
        sx={{
          pl: '16px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
        {product.must_have && (
          <div
            style={{
              display: 'flex',
              padding: '4px 8px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '4px',
              borderRadius: '29px',
              width: 'fit-content',
              background: 'var(--Salmon, #F5BE9F)',
              marginBottom: '8px',
            }}>
            <FavoriteBorderIcon
              sx={{
                fontSize: 16,
                color: '#000',
                fontFamily: 'Font Awesome 6 Pro',
              }}
            />
            <Typography sx={{ fontSize: 11, fontWeight: 500 }}>
              MUST HAVE
            </Typography>
          </div>
        )}
        <Typography
          variant="h6"
          sx={{
            fontSize: '18px',
            fontWeight: '400',
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 3,
            textOverflow: 'ellipsis',
          }}>
          {product.product_details.title}
        </Typography>
        {product.product_details.brand && (
          <Typography sx={{ fontSize: 13, opacity: '0.64' }}>
            {product.product_details.brand}
          </Typography>
        )}
        {type === 'available'
          ? product.quantity_required && (
              <Typography sx={{ fontSize: '13px' }}>
                Quantity needed:{' '}
                {product.quantity_purchased
                  ? parseInt(product.quantity_required) -
                    parseInt(product.quantity_purchased)
                  : parseInt(product.quantity_required)}
              </Typography>
            )
          : product.quantity_purchased && (
              <Typography sx={{ fontSize: '13px' }}>
                Quantity purchased: {parseInt(product.quantity_purchased)}
              </Typography>
            )}
      </Grid>
      <Grid item xs={12}>
        {product.note && (
          <Typography sx={{ fontSize: '13px', mt: '8px' }}>
            <Typography variant="span" sx={{ fontWeight: 600 }}>
              Notes: &nbsp;
            </Typography>
            <Typography variant="span">{product.note}</Typography>
          </Typography>
        )}
        {type === 'available' && (
          <Grid item xs sx={{ py: '16px' }}>
            <div
              style={{
                maxHeight: '120px',
                overflowY: 'auto',
              }}>
              {product.product_details.providers && (
                <Divider
                  sx={{
                    borderColor: 'black',
                    opacity: 1,
                  }}
                />
              )}
              {product.product_details.providers &&
                product.product_details.providers.map((provider, index) => (
                  <React.Fragment key={index}>
                    <PriceComponent
                      product={provider}
                      handleBuyNow={handleBuyNow}
                      index={index}
                    />
                    <Divider
                      sx={{
                        borderColor: 'black',
                        opacity: 1,
                      }}
                    />
                  </React.Fragment>
                ))}
            </div>
          </Grid>
        )}
        {type === 'available' && (
          <Grid
            container
            display="flex"
            justifyContent="center"
            alignItems="center">
            <Checkbox
              sx={{
                borderRadius: '4px',
                width: '16px',
                height: '16px',
                marginRight: '8px',
                '&.Mui-checked': {
                  color: 'var(--Black, #000)',
                },
              }}
              checked={isChecked}
              onChange={() => setSelectedProduct(product)}
              onClick={handlePurchaseForm}
            />
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 400,
              }}>
              I’ve purchased this
            </Typography>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default SingleProductMobile;
